import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchCredentials = () => api.get("/credentials").then((r) => r.data);

export const fetchPaperDetail = (paper_id) =>
  api.get(`/scholar/publication/${encodeURIComponent(paper_id)}`).then((r) => r.data);

export const listGoals = () => api.get("/goals").then((r) => r.data);

export const createGoal = (payload) => api.post("/goals", payload).then((r) => r.data);

export const deleteGoal = (id) => api.delete(`/goals/${id}`).then((r) => r.data);

export const fetchProfile = (refresh = false) =>
  api.get("/scholar/profile", { params: refresh ? { refresh: true } : {} }).then((r) => r.data);

export const refreshProfile = () => api.post("/scholar/refresh").then((r) => r.data);

export const fetchConfig = () => api.get("/scholar/config").then((r) => r.data);

export const updateConfig = (user_id) =>
  api.put("/scholar/config", { user_id }).then((r) => r.data);

export const createInquiry = (payload) => api.post("/inquiries", payload).then((r) => r.data);

export const listInquiries = () => api.get("/inquiries").then((r) => r.data);

export const deleteInquiry = (id) => api.delete(`/inquiries/${id}`).then((r) => r.data);

export const fetchInsights = () => api.get("/scholar/insights").then((r) => r.data);

export const regenerateInsights = () =>
  api.post("/scholar/insights/regenerate").then((r) => r.data);
